/** API client — Analyse Stock photo (Phase B). */

export async function analyzeStockPhoto(
  api,
  {
    file,
    magasinId,
    hintText = '',
    useSupplierCache = true,
    useAiVision = true,
    quantite = 1,
  },
) {
  const form = new FormData();
  form.append('file', file);
  form.append('magasin_id', magasinId);
  if (hintText.trim()) form.append('hint_text', hintText.trim());
  form.append('use_supplier_cache', useSupplierCache ? 'true' : 'false');
  form.append('use_ai_vision', useAiVision ? 'true' : 'false');
  form.append('quantite', String(quantite));

  const res = await api.post('/stock/analyze-photo', form, {
    headers: { 'X-Magasin-Session-Id': magasinId },
    timeout: 90000,
  });
  return res.data;
}

export async function analyzeStockPhotoFromHint(api, { hintText, magasinId, useSupplierCache = true, useAiVision = true, quantite = 1 }) {
  const res = await api.post(
    '/stock/analyze-photo',
    {
      hint_text: hintText,
      magasin_id: magasinId,
      use_supplier_cache: useSupplierCache,
      use_ai_vision: useAiVision,
      quantite,
    },
    { headers: { 'X-Magasin-Session-Id': magasinId }, timeout: 60000 },
  );
  return res.data;
}

export async function recalcVenteFromAchat(api, { prixAchat, mainOeuvre = 0, reference = '' }) {
  const pa = parseFloat(prixAchat) || 0;
  if (pa <= 0) return null;
  const res = await api.post('/calcul/prix', {
    items: [{ description: '', prix_achat: pa, reference }],
    quantite: 1,
    main_oeuvre: parseFloat(mainOeuvre) || 0,
  });
  return res.data;
}

export function lineFromAnalyzeResult(result) {
  const pl = result?.proposed_line || {};
  return {
    reference: pl.reference || '',
    ean: pl.ean || '',
    designation: pl.designation || '',
    categorie: pl.categorie || '',
    fournisseur: pl.fournisseur || '',
    prix_achat: pl.prix_achat ?? '',
    prix_vente: pl.prix_vente ?? '',
    quantite: pl.quantite || 1,
    magasin_id: pl.magasin_id || 'M1',
  };
}

export function queueRowsMatch(a, b) {
  const sameMag = (a.magasin_id || 'M1').toUpperCase() === (b.magasin_id || 'M1').toUpperCase();
  const sameLoc = (a.stockLocation || 'boutique') === (b.stockLocation || 'boutique');
  if (!sameMag || !sameLoc) return false;
  const refA = (a.reference || '').trim().toLowerCase();
  const refB = (b.reference || '').trim().toLowerCase();
  const eanA = (a.ean || '').trim();
  const eanB = (b.ean || '').trim();
  if (refA && refB && refA === refB) return true;
  if (eanA && eanB && eanA === eanB) return true;
  return false;
}

export function findQueueMatch(queue, candidate) {
  return queue.find((r) => queueRowsMatch(r, candidate)) || null;
}

export function mergeLineWithExistingStock(line, existing) {
  if (!existing) return { ...line, existing: null, status: line.status || 'new' };
  return {
    ...line,
    reference: existing.reference || line.reference,
    ean: existing.ean || line.ean,
    designation: line.designation || existing.designation,
    categorie: line.categorie || existing.categorie || '',
    fournisseur: line.fournisseur || existing.fournisseur || '',
    prix_achat: line.prix_achat !== '' && line.prix_achat != null ? line.prix_achat : (existing.prix_achat ?? ''),
    prix_vente: line.prix_vente !== '' && line.prix_vente != null ? line.prix_vente : (existing.prix_vente ?? ''),
    existing,
    status: 'existing',
  };
}

export function queueRowFromLine(line, { stockLocation, magasinId, existing = null }) {
  const stock = existing || line.existing || null;
  return {
    key: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    reference: (line.reference || '').trim(),
    ean: line.ean || '',
    designation: (line.designation || '').trim(),
    categorie: line.categorie || '',
    fournisseur: line.fournisseur || '',
    prix_achat: parseFloat(line.prix_achat) || 0,
    prix_vente: parseFloat(line.prix_vente) || 0,
    quantite: parseInt(line.quantite, 10) || 1,
    stockLocation,
    magasin_id: magasinId,
    existing: stock,
    status: stock ? 'existing' : 'new',
    stockArticleId: stock?.id || null,
  };
}

export function queueItemToBulkPayload(row) {
  return {
    reference: row.reference,
    ean: row.ean,
    designation: row.designation,
    categorie: row.categorie || '',
    prix_achat: row.prix_achat,
    prix_vente: row.prix_vente,
    quantite_add: row.quantite,
    location: row.stockLocation || 'boutique',
    fournisseur: row.fournisseur,
    magasin_id: row.magasin_id,
  };
}

export function queueItemToAnalyzeItem(row) {
  return {
    reference: row.reference,
    designation: row.designation,
    categorie: row.categorie || '',
    quantite_add: row.quantite,
    prix_vente: row.prix_vente,
    prix_achat: row.prix_achat,
    ean: row.ean,
    fournisseur: row.fournisseur,
    imei_list: row.imei_list || [],
  };
}
